import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {
  AVAILABLE_FILTERS_SOURCES,
  AvailableNoneNullableNumericOperators,
} from '@em/data-feed/util-types';
import {EmSelectOperandModule} from '@em/shared/mapping-engine/feature';
import {EmInputModule, EmSelectModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-with-competitors-filter',
  templateUrl: './with-competitors-filter.component.html',
  styleUrls: ['./with-competitors-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    EmSelectModule,
    EmInputModule,
    EmSelectOperandModule,
    MatSlideToggleModule,
  ],
})
export class EmWithCompetitorsFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;

  operators = AvailableNoneNullableNumericOperators;
  sources = AVAILABLE_FILTERS_SOURCES;

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
